import type { IVariable } from "@bbj-types/utils";
import { Box, Stack, Typography } from "@mui/material";
import { EditorV2 } from "@styleguide";
import { type Control, Controller } from "react-hook-form";
import type { INotifyByEmailModalForm } from "../types";

interface IObjectInputProps {
  control: Control<INotifyByEmailModalForm, void>;
  variables: IVariable[];
}
export const ObjectInput = ({ control, variables }: IObjectInputProps) => {
  return (
    <Stack
      direction="row"
      sx={{
        alignItems: "flex-start",
        gap: 1,
      }}
    >
      <Typography
        variant="body1"
        sx={{
          minWidth: "7%",
          whiteSpace: "nowrap",
          pt: 1,
        }}
      >
        Objet * :
      </Typography>
      <Box sx={{ flex: 1 }}>
        <Controller
          control={control}
          name="subject"
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <Box
              sx={{
                "& .tox-editor-header": { position: "absolute", right: 0 },
              }}
            >
              <EditorV2
                toolbar="variable"
                onChange={(_, text) => onChange(text)}
                value={value}
                variableList={variables}
                excludePlugins={["autoresize"]}
                init={{
                  height: 39,
                  min_height: 0,
                }}
              />
              {error?.message && (
                <Typography variant="caption" sx={{ color: "error.main", display: "block", mt: 0.5 }}>
                  {error.message}
                </Typography>
              )}
            </Box>
          )}
        />
      </Box>
    </Stack>
  );
};
